import { render, staticRenderFns } from "./SearchDropdown.vue?vue&type=template&id=20afb64e&scoped=true"
import script from "./SearchDropdown.vue?vue&type=script&lang=js"
export * from "./SearchDropdown.vue?vue&type=script&lang=js"
import style0 from "./SearchDropdown.vue?vue&type=style&index=0&id=20afb64e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20afb64e",
  null
  
)

export default component.exports